<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card>
            <template>
              <grid-revision
                :key="gridDocumento"
                :rowsTable="rowsTable"
              ></grid-revision>
            </template>
            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
              <v-btn
                v-if="tabSelected == 'Registro Avances'"
                :loading="loading"
                color="primary"
                dark
                class="mb-2"
                @click="downloadComplete()"
                :disabled="hasRows != true"
              >
                Descarga Completa
                <v-icon right dark>folder</v-icon>
              </v-btn>
              <v-btn
                v-if="tabSelected == 'Evolucion'"
                :loading="loading"
                color="primary"
                dark
                class="mb-2"
                @click="downloadData()"
              >
                Descarga Datos
                <v-icon right dark>cloud_download</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
          <v-dialog v-model="dialogLoading" persistent max-width="390">
            <loading-descarga></loading-descarga>
          </v-dialog>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import GridRevision from "@/modules/aplicacion/views/revision/GridRevision.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";

export default {
  name: "revision",

  components: {
    GridRevision,
    LoadingDescarga,
  },

  props: {
    //tabSelected: ""
  },

  data() {
    return {
      dialogLoading: false,
      loading: false,
      proveedor: {},
      rowsTable: [20],
      tabs: ["Acuerdo", "Progreso", "Contingencia", "Calidad"],
      contratoId: "",
      tabSelect: "",
      activeTab: "",
      index: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      filter: false,
      usuarioLogged: "",
      gridDocumento: 20,
      idEstado: "",
      tipeCenter: "",
      idContrato: "",
      tabSelected: "",
      hasRows: false,
    };
  },

  mounted() {},
  created() {
    this.tabSelected = this.$store.getters.subTabSelectedStored;
    this.usuarioLogged = this.$store.getters.userLogged;
    this.tipeCenter = this.$store.getters.subTabSelectedStored;
    this.idContrato = this.$store.getters.contratoStored;
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 4000);
    },
  },
  methods: {
    reloadDocumento() {
      this.gridDocumento += 22;
    },
    selected(tab) {
      this.tabSelect = tab;
    },

    filterDoc() {
      this.filter = true;
    },

    downloadCenter() {
      let that = this;
      let filename = "Centros_" + this.tipeCenter + ".xls";
      axios({
        url: "/centro/download/" + this.tipeCenter + "/" + this.contratoId,
        method: "GET",
        responseType: "blob",
      })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },

    downloadComplete() {
      this.dialogLoading = true;
      let filename = "Descarga_Completa_Revision.xlsx";

      axios({
        url: "/revisionMaterial/downloadRevisiones/" + this.idContrato,
        method: "GET",
        responseType: "blob",
      })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },

    // ================================================
    // EVOLUCION

    downloadData() {
      this.dialogLoading = true;
      let filename = "Revision_Materiales_Evolucion.xlsx";

      axios({
        url: "/revisionMaterial/evolucion/download/" + this.idContrato,
        method: "GET",
        responseType: "blob",
      })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
  },
};
</script>
